{
  "dss": {
    "button": {
      "back": "Назад",
      "cancel": "Откажи",
      "close": "Затвори",
      "confirmDelete": "Да, избриши",
      "continue": "Настави",
      "logout": "Одјава",
      "passwordReset": "Ресетовање лозинке",
      "save": "Сачувај",
      "verify": "Потврди"
    },
    "error": {
      "403": "Немате приступ овој страници.",
      "404": "Ова страница не постоји.",
      "generic": "Дошло је до грешке. Покушајте поново касније.",
      "throttling": "Превише покушаја. Ова операција је привремено блокирана.",
      "title": "Грешка",
      "title403": "Приступ одбијен",
      "title404": "Није пронађено"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Политика приватности",
      "terms": "Услови и одредбе"
    },
    "label": {
      "CRMAccountNumber": "CRM број налога",
      "contact": "Контакт",
      "email": "Имејл",
      "faq": "FAQ",
      "female": "Г-ђа",
      "firstname": "Име",
      "help": "Помоћ",
      "language": "Језик",
      "lastname": "Презиме",
      "male": "Г-дин",
      "needHelp": "Потребна вам је помоћ?",
      "newPassword": "Нова лозинка",
      "newPassword2": "Потврдите нову лозинку",
      "oldPassword": "Тренутна лозинка",
      "organization": "Организација",
      "password": "Лозинка",
      "required": "обавезно",
      "salutation": "Ослављање",
      "select": "Молимо изаберите"
    },
    "lang": {
      "de": "Немачки"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Потврдите регистрацију",
        "wait": "Молимо сачекајте док се потврда налога не заврши."
      },
      "otp": {
        "btnResend": "Поново пошаљи верификациони код",
        "msg": {
          "invalidOTP": "Унети једнократни код није важећи.",
          "resendFail": "Слање кода није успело. Покушајте поново касније."
        },
        "spamDetail": "Проверите пријемно сандуче и нежељену пошту за имејл од STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Нисте добили имејл?",
        "subtitle": "Да бисте наставили, морате да верификујете своју адресу е-поште.",
        "title": "Потврдите свој кориснички налог",
        "txtVerifyMail": "Унесите нови верификациони код који смо послали на адресу е-поште {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Нема ништа за ажурирање.",
          "updateError": "Није успело ажурирање личних података.",
          "updated": "Лични подаци су ажурирани.",
          "userLoadErr": "Грешка при учитавању корисничких података. Покушајте поново касније."
        },
        "secOrganization": "Организација",
        "secPersonal": "Лично",
        "secSettings": "Подешавања преференци",
        "title": "Личне информације"
      },
      "postPwSet": {
        "info": "Сада можете да користите вашу нову лозинку.",
        "link_name": "Настави на Self-Service",
        "link_url": "/user/ui/",
        "title": "Ваша лозинка је промењена"
      },
      "resetPW": {
        "title": "Ресетујте вашу лозинку"
      },
      "security": {
        "2fa": {
          "availableMethods": "Доступне 2FA методе:",
          "info": "Двофакторска аутентикација (2FA) је безбедносна функција која додаје додатни ниво заштите вашем налогу. Захтева употребу две методе за пријаву уместо само корисничког имена и лозинке.",
          "method": {
            "email": "Имејл",
            "emailDesc": "Примајте једнократне кодове путем е-поште за завршетак захтева за аутентикацију.",
            "oath": {
              "add": {
                "button": "Региструј Authenticator апликацију"
              }
            }
          }
        },
        "authenticator": "Authenticator апликација",
        "infoFederatedAccount": "Овим налогом управља провајдер идентитета ваше организације, тако да лозинка овде не може да се промени. Да бисте променили лозинку, пријавите се преко странице за пријаву ваше организације или контактирајте свог ИТ администратора.",
        "lastUse": "Последњи пут коришћено: {0}.",
        "msg": {
          "invalidPassword": "Неважећа тренутна лозинка.",
          "passwordAlreadyUsed": "Није дозвољено поновно коришћење последњих 5 лозинки.",
          "pwUpdateError": "Дошло је до грешке при промени лозинке.",
          "pwUpdated": "Лозинка је промењена."
        },
        "noDevice": "Није конфигурисано",
        "oathAdd": {
          "appInfo": "Да бисте олакшали процес пријављивања на STIHL, можете да користите Authenticator апликације као што су {0}, {1}, {2} итд. за генерисање једнократних лозинки које се користе као други фактор током процеса пријаве.<br/>Ако сте изгубили или заборавили свој мобилни уређај, увек можете да употребите 2FA код послат имејлом.<br/><br/>Пратите упутства у наставку да бисте подесили свој уређај за аутентикацију.",
          "badCode": "Неважећи код, покушајте поново.",
          "error": "Грешка при покушају регистрације уређаја за аутентикацију.",
          "headScan": "1. Скенирајте QR код вашом Authenticator апликацијом",
          "headVerify": "2. Потврдите код",
          "infoKey": "кључ за подешавање",
          "infoKeyTitle": "Ваша двофакторска тајна",
          "infoScanBottom": "Не можете да скенирате? Користите {0} да ручно подесите вашу Authenticator апликацију.",
          "infoVerify": "Унесите код који је генерисала ваша Authenticator апликација.",
          "success": "Ваш уређај за аутентикацију је регистрован. Сада можете да га користите за пријављивање.",
          "title": "Региструјте свој уређај за двофакторску аутентикацију"
        },
        "oathDelete": {
          "error": "Грешка при покушају брисања уређаја за аутентикацију.",
          "success": "Уређај за аутентикацију је обрисан."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey су парови криптографских кључева (јавни и приватни кључ) које чува аутентификатор под вашом контролом. Аутентификатор може доказати да је корисник присутан и овлашћен да користи passkey. Овлашћење се доказује путем PIN-а, кода, биометрије или лозинке уређаја, у зависности од могућности и конфигурације аутентификатора. Аутентификатори постоје у различитим облицима: iPhone или Android уређај, Windows Hello, FIDO2 хардверски безбедносни кључ или менаџер лозинки.",
            "info2": "Када се пријављујете на STIHL користећи passkey, ваш аутентификатор користи криптографију са јавним кључем да докаже ваш идентитет STIHL-у без слања самог passkey-а. Passkey-ји су везани за домен веб-сајта, као што је stihl-sso.com, и захтевају безбедну везу, што значи да ће прегледач одбити аутентикацију на лажном фишинг веб-сајту. Ове особине чине passkey-је веома отпорним на фишинг и много тежим за напад од SMS или TOTP 2FA.",
            "info3": "Cloud услуге за passkey омогућавају синхронизацију кључева између уређаја (као што су Apple уређаји, Android уређаји или менаџери лозинки) тако да се могу користити на више места и теже изгубити. Након што подесите синхронизован passkey на једном уређају, он је доступан на више уређаја који користе исту услугу. На пример, ако региструјете passkey са вашим iCloud налогом користећи Touch ID на MacBook-у, касније можете користити тај passkey са лицем, отиском прста, PIN-ом или лозинком уређаја на више уређаја повезаних са истим iCloud налогом.",
            "title": "О Passkeys"
          },
          "add": {
            "button": "Додај нови Passkey",
            "error": "Грешка при додавању новог passkey-а.",
            "success": "Нови passkey је додат."
          },
          "delete": {
            "button": "Избриши Passkey",
            "error": "Грешка при брисању овог passkey-а.",
            "success": "Passkey је обрисан."
          },
          "edit": {
            "error": "Грешка при чувању имена passkey-а.",
            "name": "Назив Passkey",
            "success": "Назив passkey-а је ажуриран.",
            "title": "Дајте свом Passkey-ју име да бисте га разликовали од других"
          },
          "info": "Passkey је једноставна и безбедна алтернатива лозинкама, која потврђује ваш идентитет коришћењем додира, препознавања лица, лозинке уређаја или PIN-а.",
          "none": "Нема конфигурисаних Passkey-ја.",
          "reallyDelete": "Да ли сте сигурни да желите да обришете Passkey?",
          "registeredPasskeys": "Ваши регистровани Passkey-ји:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Да ли сте сигурни да желите да обришете уређај за аутентикацију?",
        "secMFA": "Двофакторска аутентикација",
        "secPwdChange": "Промени лозинку",
        "title": "Безбедност"
      },
      "setPW": {
        "acceptTC": "Потврдите наше {terms} и прочитајте нашу {privacy}.",
        "killSSO": "Поништити све активне сесије",
        "msg": {
          "tokenExpired": "Веза или код за лозинку је истекао. Пратите везу да ресетујете лозинку: {link}."
        },
        "privacy": "Политика заштите података",
        "terms": "Услови и одредбе",
        "title": "Унесите нову лозинку"
      }
    },
    "validations": {
      "hasDigit": "Мора да садржи цифру(е)",
      "hasLowercase": "Мора да садржи мала слова",
      "hasSpecial": "Мора да садржи специјалне знакове: {chars}",
      "hasUppercase": "Мора да садржи велика слова",
      "invalidCharacters": "Садржи неважеће знаке",
      "maxLength": "Дозвољено је највише {max} знакова",
      "minLength": "Потребно је најмање {min} знакова",
      "notSameAsEmail": "Превише слично адреси е-поште",
      "onlyValidCharactersAllowed": "Дозвољена су само слова, бројеви и размаке.",
      "required": "Обавезно поље",
      "sameAsPassword": "Лозинке се не поклапају",
      "tcAccepted": "Потврдите наше услове и одредбе.",
      "validEmail": "Неважећа адреса е-поште.",
      "validOTP": "Унесите верификациони код."
    }
  }
}
